module.exports = __webpack_public_path__ + "static/media/menu1.d3ce7964.jpeg";